import React, { useContext, useState, useEffect } from "react";
import SideBar from "../../../components/SideBar/SideBar";
import "../../Styles/globalStyle.css";
import useSize from "../../../Hooks/useSize.js";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function SideBarMenu(props) {
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  const buildStyle = useBuildStyle();

  useEffect(() => {
    
    props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);

  const getContainerStyle = () => {
    var newStyle = buildStyle(props.style); 
    
    newStyle["left"] = "0";
    newStyle["backgroundColor"] = "transparent";

    
    return newStyle;
  };

 
  return (
    <div  draggable={props.draggable}
      onDragStart={(e) => props.onDragStart(e)}
      id={props.data.id}
      style={getContainerStyle()}
      onClick={props.onClick}>
  
      <SideBar width={props.width} height={props.height} />
       
    
    </div>
  );
}
